import OxVue from '../OxVue'
import { Component, ProvideReactive } from 'vue-property-decorator'
import { KhSnackbarManager, SnackbarManager } from '@internal-libraries/kheops-ui-lib'
import { Nullable } from '@internal-libraries/kheops-ui-lib'

/**
 * KhVueSolo
 *
 * Wrapper général de l'application Vue.
 */
@Component({
    components: {
        KhSnackbarManager,
    },
})
export default class KhVueSolo extends OxVue {
    @ProvideReactive() public snackbarManager: Nullable<SnackbarManager> = null
}
